import * as z from 'zod';

const promotionMaxUsageUnitCodes = z.union([
    z.literal('piece'),
    z.literal('kg'),
    z.literal('unknown'),
]);

const promotionMaxUsageUnitSchema = z
    .object({
        code: promotionMaxUsageUnitCodes,
        name: z.string(),
        shortName: z.string(),
    })
    .readonly();

type UsageUnit = z.infer<typeof promotionMaxUsageUnitSchema>;

export const promotionMaxUsageSchema = z
    .object({
        value: z.number().min(0),
        unit: promotionMaxUsageUnitSchema,
        scope: z.string().nullable().optional(),
    })
    .readonly();

export type PromotionMaxUsage = z.infer<typeof promotionMaxUsageSchema>;

export const KnownPromotionUsageUnitMap = {
    piece: { code: 'piece', name: 'styck', shortName: 'st' } satisfies UsageUnit,
    kg: { code: 'kg', name: 'kilogram', shortName: 'kg' } satisfies UsageUnit,
    unknown: (value: string) => ({
        code: 'unknown',
        name: String(value).toLowerCase(),
        shortName: String(value).toLowerCase(),
    }),
} as const;

export const formatPromotionMaxUsage = (obj: PromotionMaxUsage) => {
    return `Erbj: Max ${obj.value} ${obj.unit.shortName}${obj.scope && `/${obj.scope}`}`.trim();
};

export const formatPromotionMaxUsageA11y = (obj: PromotionMaxUsage) => {
    return `Erbjudandet är begränsat till max ${obj.value} ${obj.unit.name}${obj.scope && ` per ${obj.scope}`}`.trim();
};
